import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  FormControl,
  IconButton,
  Divider,
} from "@mui/material"
import React, { useEffect } from "react"
import ClearIcon from "@mui/icons-material/Clear"

import { z } from "zod"
import SingleSelect from "@/components/Select/SingleSelect"
import { DevTool } from "@hookform/devtools"
import { useAddModel } from "@/hooks/useAddModel"

const StoreSchema = z.object({
  name: z.string().min(3),
  location: z.string(),
  phone: z.string(),
  vat_pan_number: z.string().optional().nullable(),
})

const AddStoreModal = ({ open, onClose }) => {
  const {
    errors,
    openDialog,
    isSubmitting,
    selectedRow,
    control,
    Controller,
    register,
    handleSubmit,
    setValue,
    onSubmit,
    handleReset,
    defaultOnClose,
  } = useAddModel("stores", StoreSchema)

  useEffect(() => {
    if (selectedRow) {
      setValue("name", selectedRow.name)
      setValue("location", selectedRow.location)
      setValue("phone", selectedRow.phone)
      setValue("vat_pan_number", selectedRow.vat_pan_number)
    }
  }, [selectedRow])

  return (
    <Modal
      open={open ? open : openDialog}
      onClose={defaultOnClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          width: 800,
          margin: "100px auto",
          bgcolor: "white",
          borderRadius: 2,
          boxShadow: 3,
          padding: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f6f7f9",
            padding: { xs: "15px 20px", md: "25px" },
          }}
          className="rmu-modal-header"
        >
          <Typography
            id="modal-modal-title"
            variant="h6"
            sx={{
              fontWeight: "600",
              fontSize: { xs: "16px", md: "18px" },
            }}
            className="text-black"
          >
            {selectedRow ? "Update Store" : "Add New Store"}
          </Typography>
          <IconButton
            aria-label="remove"
            size="small"
            onClick={onClose ? onClose : defaultOnClose}
          >
            <ClearIcon />
          </IconButton>
        </Box>
        <Box
          sx={{ padding: 2 }}
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <Typography
            id="modal-modal-title"
            variant="h6"
            sx={{
              fontWeight: "500",
              fontSize: { xs: "12px", md: "16px" },
              marginBottom: 2,
            }}
            className="text-black"
          >
            Basic Information
          </Typography>
          <TextField
            fullWidth
            label="Name"
            sx={{ marginBottom: 2 }}
            error={!!errors.name}
            helperText={errors.name?.message}
            {...register("name")}
          />
          <TextField
            fullWidth
            label=" Phone"
            sx={{ marginBottom: 2 }}
            error={!!errors.phone}
            helperText={errors.phone?.message}
            {...register("phone")}
          />
          <Grid item xs={12} md={12} lg={6} sx={{ marginBottom: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <TextField
                fullWidth
                label="Location"
                sx={{ marginBottom: 2 }}
                error={!!errors.location}
                helperText={errors.location?.message}
                {...register("location")}
              />
              <TextField
                fullWidth
                label="PAN/VAT Number"
                error={!!errors.vat_pan_number}
                helperText={errors.vat_pan_number?.message}
                {...register("vat_pan_number")}
              />
            </Box>
          </Grid>
          <Grid item xs={12} mt={1}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: "10px",
              }}
            >
              <Button
                onClick={handleReset}
                variant="text"
                sx={{
                  textTransform: "capitalize",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "13px",
                  padding: "11px 30px",
                }}
              >
                Reset
              </Button>

              <Button
                onClick={onClose ? onClose : defaultOnClose}
                variant="outlined"
                color="error"
                sx={{
                  textTransform: "capitalize",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "13px",
                  padding: "11px 30px",
                }}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={isSubmitting}
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "13px",
                  padding: "11px 30px",
                  color: "#fff !important",
                }}
              >
                {selectedRow ? "Update" : "Create"}
              </Button>

              {/* remove this after form completion */}
              <DevTool control={control}></DevTool>
            </Box>
          </Grid>
        </Box>
      </Box>
    </Modal>
  )
}

export default AddStoreModal
